class ProductImageSlider extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.startX = 0;
    this.isDragging = false;
    this.threshold = 50;
  }

  connectedCallback() {
    this.gallery = this.querySelector('[ref="gallery"]');
    this.slides = this.querySelectorAll('[ref="slide[]"]');
    this.dots = this.querySelectorAll('[ref="dot[]"]');
    this.prevBtn = this.querySelector('[ref="prevBtn"]');
    this.nextBtn = this.querySelector('[ref="nextBtn"]');

    if (!this.gallery || this.slides.length === 0) return;

    this.setupEventListeners();
  }

  setupEventListeners() {
    // Flèches
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.goToPrevious());
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.goToNext());
    }

    // Dots
    this.dots.forEach((dot) => {
      dot.addEventListener('click', (e) => {
        const index = parseInt(e.target.dataset.slideIndex);
        this.goToSlide(index);
      });
    });

    // Swipe / Drag
    this.gallery.addEventListener('touchstart', (e) => this.handleDragStart(e), false);
    this.gallery.addEventListener('touchmove', (e) => this.handleDragMove(e), false);
    this.gallery.addEventListener('touchend', (e) => this.handleDragEnd(e), false);

    // Mouse drag desktop
    this.gallery.addEventListener('mousedown', (e) => this.handleDragStart(e), false);
    this.gallery.addEventListener('mousemove', (e) => this.handleDragMove(e), false);
    this.gallery.addEventListener('mouseup', (e) => this.handleDragEnd(e), false);
    this.gallery.addEventListener('mouseleave', (e) => this.handleDragEnd(e), false);
  }

  handleDragStart(e) {
    this.isDragging = true;
    this.startX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
  }

  handleDragMove(e) {
    if (!this.isDragging) return;
    // Optionnel: on peut ajouter une preview du drag si souhaité
  }

  handleDragEnd(e) {
    if (!this.isDragging) return;
    this.isDragging = false;

    const endX = e.type.includes('mouse') ? e.clientX : e.changedTouches[0].clientX;
    const diff = this.startX - endX;

    if (Math.abs(diff) > this.threshold) {
      if (diff > 0) {
        // Swipe gauche → image suivante
        this.goToNext();
      } else {
        // Swipe droite → image précédente
        this.goToPrevious();
      }
    }
  }

  goToNext() {
    this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    this.updateSlider();
  }

  goToPrevious() {
    this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    this.updateSlider();
  }

  goToSlide(index) {
    this.currentIndex = index;
    this.updateSlider();
  }

  updateSlider() {
    // Scroll vers la slide
    const scrollLeft = this.slides[this.currentIndex].offsetLeft;
    this.gallery.scrollLeft = scrollLeft;

    // Update des dots
    this.dots.forEach((dot, index) => {
      if (index === this.currentIndex) {
        dot.classList.add('product-image-slider__dot--active');
        dot.setAttribute('aria-selected', 'true');
      } else {
        dot.classList.remove('product-image-slider__dot--active');
        dot.setAttribute('aria-selected', 'false');
      }
    });

    // Gestion des flèches
    if (this.prevBtn && this.nextBtn) {
      this.prevBtn.style.opacity =
        this.currentIndex === 0 ? '0.5' : '1';
      this.nextBtn.style.opacity =
        this.currentIndex === this.slides.length - 1 ? '0.5' : '1';
    }
  }
}

if (!customElements.get('product-image-slider')) {
  customElements.define('product-image-slider', ProductImageSlider);
}